module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a-layout-sider', {
    staticClass: "sider",
    attrs: {
      "width": "273"
    }
  }, [_c('setting-item', {
    attrs: {
      "title": "导航栏颜色"
    }
  }, [_c('img-checkbox-group', {
    on: {
      "change": _vm.setTheme
    }
  }, [_c('img-checkbox', {
    attrs: {
      "img": "static/img/side-bar-dark.svg",
      "checked": _vm.dark,
      "value": "dark"
    }
  }), _vm._v(" "), _c('img-checkbox', {
    attrs: {
      "img": "static/img/side-bar-light.svg",
      "checked": !_vm.dark,
      "value": "light"
    }
  })], 1)], 1), _vm._v(" "), _c('setting-item', {
    attrs: {
      "title": "主题颜色"
    }
  }, [_c('color-checkbox-group', {
    attrs: {
      "defaultValues": _vm.defaultValues,
      "multiple": false
    },
    on: {
      "change": _vm.onColorChange
    }
  }, [_vm._l((_vm.colorList), function(color, index) {
    return [_c('color-checkbox', {
      key: index,
      attrs: {
        "color": color,
        "value": index + 1
      }
    })]
  })], 2)], 1), _vm._v(" "), _c('a-divider'), _vm._v(" "), _c('setting-item', {
    attrs: {
      "title": "导航栏位置"
    }
  }, [_c('img-checkbox-group', {
    on: {
      "change": _vm.setLayout
    }
  }, [_c('img-checkbox', {
    attrs: {
      "img": "static/img/side-bar-left.svg",
      "checked": _vm.side,
      "value": "side"
    }
  }), _vm._v(" "), _c('img-checkbox', {
    attrs: {
      "img": "static/img/side-bar-top.svg",
      "checked": !_vm.side,
      "value": "head"
    }
  })], 1)], 1), _vm._v(" "), _c('setting-item', [_c('a-list', {
    attrs: {
      "split": false
    }
  }, [_c('a-list-item', [_vm._v("\n        固定顶栏\n        "), _c('a-switch', {
    attrs: {
      "slot": "actions",
      "checked": _vm.fixHeader,
      "size": "small"
    },
    on: {
      "change": _vm.setFixHeader
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('a-list-item', [_vm._v("\n        固定侧边栏\n        "), _c('a-switch', {
    attrs: {
      "slot": "actions",
      "checked": _vm.fixSiderbar,
      "size": "small"
    },
    on: {
      "change": _vm.setFixSiderbar
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('a-list-item', [_vm._v("\n        多页签模式\n        "), _c('a-switch', {
    attrs: {
      "slot": "actions",
      "checked": _vm.multipage,
      "size": "small"
    },
    on: {
      "change": _vm.setMultipage
    },
    slot: "actions"
  })], 1)], 1)], 1), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "icon": "save"
    },
    on: {
      "click": _vm.updateUserConfig
    }
  }, [_vm._v("保存设置")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-bb3fad04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/setting/Setting.vue
// module id = qzH+
// module chunks = 273